import {ActivityArea, CompanySuggestion, Experience} from './Experience';
import {ExperienceRepository} from './ExperienceRepository';

function _isDateBefore(date: Date, limit: Date): boolean {
    if (date.getTime() > limit.getTime()) {
        return false;
    }

    return true;
}

function _areValidDates(experience): boolean {
    let areValid = true;

    if (!experience.startDate) {
        areValid = false;
    } else {
        // Start date <= today
        const currentDate = new Date();

        if (!_isDateBefore(experience.startDate, currentDate)) {
            return false;
        }

        // no endDate if isCurrentJob
        if (!experience.isCurrentJob) {
            if (!experience.endDate) {
                return false;
            } else {
                // Start date <= End Date <= Today
                if (!_isDateBefore(experience.startDate, experience.endDate) || !_isDateBefore(experience.endDate, currentDate)) {
                    return false;
                }
            }
        }
    }

    return areValid;
}
const validate = {
    area: (experience: Experience) => !!experience.area && experience.area.length > 0,
    company: (experience: Experience) => !!experience.company && experience.company.length > 0,
    description: (experience: Experience) => !!experience.description && experience.description.length > 0,
    title: (experience: Experience) => !!experience.title && experience.title.length > 0,
    location: (experience: Experience) => !!experience.location && !!experience.location.formattedAddress,
    dates: (experience) => _areValidDates(experience),
};

export class ExperienceDomainService {
    constructor(readonly experienceRepository: ExperienceRepository) {}

    async fetchActivityAreas(): Promise<ActivityArea[]> {
        return await this.experienceRepository.fetchActivityAreas();
    }

    async fetchExperiences(): Promise<Experience[]> {
        return await this.experienceRepository.fetchExperiences();
    }

    async updateExperiences(experiences: Experience[]): Promise<void> {
        return await this.experienceRepository.updateExperiences(experiences);
    }

    async searchCompanies(query: string): Promise<CompanySuggestion[]> {
        return await this.experienceRepository.searchCompanies(query);
    }

    isValidExperience(experience: Experience): boolean {
        return (
            validate.area(experience) &&
            validate.company(experience) &&
            validate.description(experience) &&
            validate.title(experience) &&
            validate.location(experience) &&
            validate.dates(experience)
        );
    }
}
